import Box from '@mui/material/Box'
import styled from '@mui/material/styles/styled'

export const Title = styled(Box, {
  name: 'Name',
  slot: 'Root',
  skipSx: true,
})`
  font-size: 16px;
`
